import { ConfirmModalAction } from "./ConfirmModalAction";
import { ConfirmModalActions } from "./ConfirmModalActions";
import { ConfirmModalContent } from "./ConfirmModalContent";
import { ConfitmModalRoot } from "./ConfirmModalRoot";
import { ConfirmModalTitle } from "./ConfirmModalTitle";

export const ConfirmModal = {
    Action: ConfirmModalAction,
    Actions: ConfirmModalActions,
    Content: ConfirmModalContent,
    Root: ConfitmModalRoot,
    Title: ConfirmModalTitle,
}


// WEBPACK FOOTER //
// ./src/component/shared/confirm-modal/index.tsx